import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/shared/api/client';
import { endpoints } from '@/shared/api/endpoints';
import { getEndpoint } from '@/shared/utils/getUrl';
import { useAppStore } from '@/shared/store/useAppStore';
import type { UserData } from './types';

export const useCompleteProductOnboarding = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userId: string) => {
      const response = await apiClient.post<Pick<UserData, 'product_onboarding_completed_at'>>(
        getEndpoint(endpoints.users.completeOnboarding)
      );
      return { userId, ...response.data };
    },
    retry: 2,
    onSuccess: ({ userId, product_onboarding_completed_at }) => {
      const { user, setUser } = useAppStore.getState();
      if (user?.id !== userId) return;
      const updated = { ...user, product_onboarding_completed_at };
      setUser(updated);
      queryClient.setQueryData<UserData>(['user', 'me'], updated);
    },
  });
};
